// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatagnosissdai } from "../../../icons/mono/build/icon-statagnosissdai.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatagnosissdaiIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatagnosissdai.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatagnosissdaiIcon.displayName = 'StatagnosissdaiIcon';
}

export default StatagnosissdaiIcon;